export interface DateDisplayConfig {
  format?: string;
  justifyContentForDisplay?: boolean;
}
